/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const SECRETS = {
	/** Attempt to renew token every 30 seconds. */
	VAULT_RENEW_INTERVAL: 30000
};
